import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Pagination from "rc-pagination";
import { getNewsList, getSearch, getAds } from "actions/requests";
import NewsSidebar from "./../../component/News/NewsSidebar";
import styles from "./Search.module.scss";
import ContainerFluid from "./../../component/ContainerFluid";
import Header from "component/Header/Header";
import Footer from "./../../component/Footer";
import StickyContact from "component/StickyContact";
import NewsCardHorizontal from "./../../component/News/NewsCardHorizontal";
import ServiceCardHorizontal from "component/ServiceCardHorizontal";
import langContent from "../../i18n/search";
import RegisterDocument from "./../../component/News/RegisterDocument";
import en from "rc-pagination/lib/locale/en_US";
import vi from "rc-pagination/lib/locale/vi_VN";
import "rc-pagination/assets/index.css";

const Search = ({ newsList, locale, hotNews, banner, linkedin }) => {
  const router = useRouter();
  const SearchStr = router.query.q || "";
  const [query, setQuery] = useState({
    service: [],
    news: [],
  });
  const [filter, setFilter] = useState({
    page: 1,
    perPage: 6,
    status: 1,
    keywords: SearchStr,
    lang_id: locale === "vi" ? 1 : 2,
  });

  useEffect(() => {
    if (SearchStr) {
      setQuery((prev) => ({
        ...prev,
        service: langContent.service.filter(
          (item) =>
            item.title[locale]
              .toLowerCase()
              .includes(SearchStr.toLowerCase()) ||
            item.sub_title[locale]
              .toLowerCase()
              .includes(SearchStr.toLowerCase())
        ),
      }));
    } else router.push("/");
  }, [SearchStr, router]);

  useEffect(() => {
    setQuery((prev) => ({ ...prev, news: newsList.data }));
  }, [newsList]);

  useEffect(() => {
    setFilter({
      page: 1,
      perPage: 6,
      status: 1,
      keywords: SearchStr,
      lang_id: locale === "vi" ? 1 : 2,
    });
  }, [locale]);

  const handleChangePage = (current, pageSize) => {
    setFilter((prev) => ({ ...prev, page: current, perPage: pageSize }));
    getSearch({ ...filter, page: current, perPage: pageSize }).then((res) =>
      setQuery((prev) => ({ ...prev, news: res.data.data }))
    );
  };

  return (
    <ContainerFluid>
      <Header />
      <div className="container">
        <div className="row my-5">
          <div className="col-12">
            {locale === "vi" ? (
              <p>
                Có <strong>{newsList.total + query.service.length}</strong> kết
                quả tìm kiếm cho "<strong>{SearchStr}</strong>"
              </p>
            ) : (
              <p>
                There are{" "}
                <strong>{newsList.total + query.service.length}</strong> search
                results for "<strong>{SearchStr}</strong>"
              </p>
            )}

            <hr className="mb-5" />
          </div>
          <div className="col-12 col-lg-9">
            {query.service.length > 0 && (
              <>
                <h4>{locale === "vi" ? "Giải pháp" : "Solutions"}</h4>
                <hr className="mb-5" />
                {query.service.map((item, index) => (
                  <div key={item.id.toString()}>
                    <ServiceCardHorizontal
                      id={item.slug}
                      title={item.title[locale]}
                      description={item.sub_title[locale]}
                      lottieFile={item.lotties}
                      isHighlight
                      query={SearchStr}
                    />
                    {index < query.service.length - 1 && <hr />}
                  </div>
                ))}
              </>
            )}
            {query.news?.length > 0 && (
              <>
                <h4>{locale === "vi" ? "Tin tức" : "News"}</h4>
                <hr className="mb-5" />
                {query.news.map((item, index) => (
                  <div key={item.id.toString()}>
                    <NewsCardHorizontal
                      slug={item.slug}
                      id={item.id}
                      title={item.title}
                      desc={item.short_content}
                      created_at={item.created_at}
                      src={
                        item?.images?.image
                          ? process.env.NEXT_PUBLIC_MEDIA_FILE +
                            item.images.image
                          : "/static/news_thumb.png"
                      }
                      locale={locale}
                      isHighlight
                      query={SearchStr}
                    />
                    {index < query.news?.length - 1 && <hr className="mt-5" />}
                  </div>
                ))}
                <div className="col-lg-12 mt-4 mb-5 mb-lg-0">
                  <Pagination
                    pageSize={filter.perPage}
                    total={newsList.total}
                    current={filter.page * 1}
                    onChange={handleChangePage}
                    locale={locale === "vi" ? vi : en}
                  />
                </div>
              </>
            )}
          </div>
          <div className="col-12 col-lg-3">
            <NewsSidebar
              bannerLink={banner?.data[0]?.data_info?.link}
              bannerUrl={banner?.data[0]?.images?.image}
              hotNews={hotNews}
              locale={locale}
              linkedin={linkedin}
            />
          </div>
        </div>
        <div className="row mb-5">
          <div className="d-none d-md-block col-lg-12">
            <RegisterDocument locale={locale} className="px-5" />
          </div>
          <div className="d-block d-md-none col-lg-12">
            <RegisterDocument locale={locale} vertical />
          </div>
        </div>
      </div>
      <Footer />
      <StickyContact className={styles.stickyContact} />
    </ContainerFluid>
  );
};

export const getServerSideProps = async (params) => {
  const typeImage = {
    banner: 1,
    popup: 2,
  };
  let data = {};

  if (params?.query?.q) {
    data = await getSearch({
      status: 1,
      page: 1,
      perPage: 6,
      keywords: params.query.q,
      lang_id: params.locale === "vi" ? 1 : 2,
    });
  }

  const hotNews = await getNewsList({
    status: 1,
    hot: 1,
    lang_id: params.locale === "vi" ? 1 : 2,
  });

  const banner = await getAds({
    page: 1,
    perPage: 1,
    type: typeImage.banner,
    status: 1,
    lang_id: params.locale === "vi" ? 1 : 2,
  });

  const linkedin = await getAds({
    page: 1,
    perPage: 1,
    type: typeImage.linkedin,
    status: 1,
    lang_id: params.locale === "vi" ? 1 : 2,
  });

  return {
    props: {
      newsList: data?.data || {},
      hotNews: hotNews?.data,
      banner: banner?.data,
      linkedin: linkedin?.data,
    },
  };
};

export default Search;
